import { UsersModule, unifiedUsersFilterModule } from '@/core/modules/users'
import { AppModule } from '@core/modules/app/app.module'
import { SearchFilterSection } from '@/ui/components/searchFilterSection'
import DashboardPage from '@components/pages/dashboard'
import OpenIssuesSkeleton from '@routes/fraud-defense/routes/open-issues/skeleton'
import {
    OpenIssuesPageWrapper,
    InfoBannerWrapper,
    ErrorMessageWrapper,
} from './fraud-defense.open-issues.route.styles'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import { TitleWrapper } from '@routes/digital-footprint/routes/assets/assets.styles'
import { InlineScanIndicator } from '@/ui/components/inline-scan-indicator'
import Typography from '@/ui/components/typography'
import { InfoBanner } from '@/ui/components/BannerAlert'
import { FC } from 'react'
import { useFraudDefenseStatus } from './hooks/useFraudDefenseRoute'
import { FdIssuesTable } from '@/ui/components/fd-issues-table'
import { BecIssuesSection } from '@/ui/components/bec-issues-table'

const OpenIssuesPage: FC = () => {
    const { error, loading } = UsersModule.useStore()
    const { scanInProgress } = AppModule.useStore()
    const allIssues = UsersModule.getUsersIssues({
        disableFilters: true,
    })
    const { fdStatusData } = useFraudDefenseStatus()
    const {
        search,
        filterConfig,
        data,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
    } = useUnifiedFilter({
        filterModule: unifiedUsersFilterModule,
        data: allIssues,
    })
    const filteredFdIssues = data.filter(
        (issue) => issue.issue_type === 'FRAUD_DEFENSE'
    )
    const becIssues = UsersModule.getBecIssuesAsIssues()

    if (error) {
        return (
            <OpenIssuesPageWrapper>
                <DashboardPage name="fraud-defense-open-issues">
                    <div className="page-content">
                        <ErrorMessageWrapper>
                            <h3>Error loading fraud defense data:</h3>
                            <p>{error}</p>
                        </ErrorMessageWrapper>
                    </div>
                </DashboardPage>
            </OpenIssuesPageWrapper>
        )
    }

    return (
        <OpenIssuesPageWrapper>
            <DashboardPage
                name="fraud-defense-open-issues"
                loading={loading}
                hideScanInProgress
                skeleton={<OpenIssuesSkeleton />}
            >
                <div className="page-content">
                    <BecIssuesSection issues={becIssues} />
                    <TableWrapper>
                        <TitleWrapper>
                            <Typography variant="m-regular">
                                Fraud Defense Issues
                            </Typography>
                            <InlineScanIndicator
                                scanInProgress={!!scanInProgress}
                            />
                        </TitleWrapper>
                        {fdStatusData && (
                            <InfoBannerWrapper>
                                <InfoBanner
                                    variant="error"
                                    title={
                                        <Typography variant="s-semibold">
                                            {fdStatusData.title}
                                        </Typography>
                                    }
                                    description={fdStatusData.description}
                                    dataTestId="fd-status-banner"
                                />
                            </InfoBannerWrapper>
                        )}
                        <SearchFilterSection
                            allItems={filteredFdIssues}
                            filteredItems={filteredFdIssues}
                            searchValue={search}
                            onSearchChange={handleSearchChange}
                            onFilterChange={handleFilterChange}
                            getFilterOptions={getFilterOptions}
                            filterConfig={filterConfig}
                            onFilterReset={handleFilterReset}
                            searchPlaceholder="Search Issues..."
                            itemLabel="Issues"
                        />
                        <FdIssuesTable issues={filteredFdIssues} />
                    </TableWrapper>
                </div>
            </DashboardPage>
        </OpenIssuesPageWrapper>
    )
}

export default OpenIssuesPage
